import React, { useState, useEffect } from "react";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import localization from "assets/localization/localization";
import Regex from "services/utils/regex/Regex";
import Images from "assets/images/imageData";
import { Button } from "react-bootstrap";

const Filters = ({
                     showFilter = false,
                     filterToggle,
                     applyFilter
                 }) => {
    const filterInputs = {
        invoice_no:'',
    };

    const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                applyFilter(filterFieldsData);
                filterFieldsData && localStorage.setItem("valet_invoice_b2b", JSON.stringify(filterFieldsData));
            }}
        >
            <div className={showFilter ? "show-filter" : ""}>
                {showFilter && (
                    <div className="filter-wrapper">
                        <div className="filter-heading">
                            <h4>Filters</h4>
                            <Button onClick={filterToggle} className="close">
                                <i className="close"></i>
                            </Button>
                        </div>
                        <div className="filter-body scrollbar-styling">
                            <ConstantInput
                                label={localization.invoiceNo}
                                value={""}
                                regex={Regex.number.test(
                                    filterFieldsData && filterFieldsData?.site_number
                                )}
                                handleChange={(val) => {
                                    setFilterFieldsData({ ...filterFieldsData, invoice_no: val });
                                }}
                            />

                            <div className="btn-wrapper">
                                <button
                                    disabled={false}
                                    type="submit"
                                    className="btn btn-primary"
                                >
                                    {localization.applyFilter}
                                    <img src={Images?.ArrowRight} alt="" />
                                </button>
                                <br />
                                <br />
                                <button
                                    onClick={() => {
                                        localStorage.setItem(
                                            "applyFilter",
                                            JSON.stringify(filterInputs)
                                        );
                                        applyFilter(filterInputs);
                                        localStorage.setItem("valet_invoice_b2b", JSON.stringify({}));
                                    }}
                                    type="button"
                                    className="btn btn-primary"
                                >
                                    {localization.removeFilter}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </form>
    );
};

export default Filters;
